export enum SubcontractorTypes {
  Lighting = "lighting",
  HVAC = "hvac",
  Refrigeration = "refrigeration",
}
